module.exports = __webpack_public_path__ + "static/media/pro.a2156680.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/pro.jpeg
// module id = 2055
// module chunks = 0